<form [formGroup]="form"
      class="form-container">
    <div>
        <h3>{{ label }}</h3>
    </div>
    <div class="input-container">
        <mat-form-field
            class="time-form-field"
            appearance="outline">
            <mat-label>HH</mat-label>
            <input
                matInput
                #hoursInput
                type="text"
                pattern="[0-9]*"
                digitOnly
                maxlength="2"
                [formControlName]="hourFormControlName"
                (focus)="setFocusBehavior()"
                (change)="updateHoursFromInput($event.target.value)"
                (keyup)="trySwitchToNextInput($event, nextInputType.Minutes)"
                (keydown)="preventSwitchToAnotherInputOnKeyDown()"
                autocomplete="off"
                class="input-text"
                placeholder="0"
                min="1"
                max="12">
        </mat-form-field>
        <span class="span-dots">:</span>
        <mat-form-field
            [class]="'time-form-field'"
            appearance="outline">
            <mat-label>MM</mat-label>
            <input
                matInput
                #minutesInput
                type="text"
                pattern="[0-9]*"
                digitOnly
                autocomplete="off"
                maxlength="2"
                [formControlName]="minutesFormControlName"
                (focus)="setFocusBehavior()"
                (change)="updateMinutesFromInput($event.target.value)"
                (keyup)="trySwitchToNextInput($event, nextInputType.Hours)"
                (keydown)="preventSwitchToAnotherInputOnKeyDown()"
                class="input-text"
                placeholder="00"
                min="0"
                max="59">
        </mat-form-field>
        <span class="meridiem-material-container">
            <div
                [class.active]="meridiem === 'am'"
                class="meridiem-material-pick"
                color="primary"
                (click)="updateMeridiem('am')">
                    AM
            </div>
            <div
                [class.active]="meridiem === 'pm'"
                class="meridiem-material-pick"
                (click)="updateMeridiem('pm')">
                    PM
                </div>
        </span>
        <!-- The functionality of clock timepicker-->
        <form [formGroup]="ignoreMandatoryGroup">
            <mat-form-field
                [hidden]="true"
                appearance="fill">
                    <mat-label>{{ label }}</mat-label>
                    <input
                        mode="12h"
                        color="primary"
                        matTimepicker
                        tabindex="-1"
                        [disableDialogOpenOnClick]="true"
                        formControlName="ignore"
                        placeholder="hh:mm am/pm"
                        (timeChange)="timePickerChangeHandler($event)"
                        [minDate]="minimumTimeFrom"
                        [value]="defaultTimeValue"
                        #timePicker="matTimepicker"
                        required>
            </mat-form-field>
        </form>
        <button
            class="time-picker-icon"
            [hidden]="!showTimepickerDialog"
            [disabled]="!showTimepickerDialog"
            mat-icon-button
            tabindex="-1"
            matSuffix
            (click)="timePicker.showDialog()">
                <mat-icon>access_time</mat-icon>
        </button>
    </div>
</form>
